import { MapOptions } from '../../../../core/types/types';

export const defaultMapOptions: MapOptions = {
    attributes: {
        canZoom: true,
    },
    styles: {
        polygon: {
            color: null,
        },
    },
    tools: {
        tiles: true,
        currentCoords: true,
        measureTool: true,
        editButton: true,
        deleteButton: true,
        breakpoints: false,
        drawPolyline: true,
        drawPolygon: true,
        dragControl: true,
    },
    editControl: true,
    tileLayer: true,
    gridCellService: false,
    buttons: {
        fullScreen: true,
        zoom: true,
    },
    theme: {
        markerColor: 'red',
    },
    mapLocked: false,
};
